

<template>

  <b-container style="margin-top: 20px">
    <b-jumbotron
      header="Você recebeu um convite para usar o App Veins Energia."
      lead="Use o código abaixo para se cadastrar."
    >
      <p style="font-size: 50px; margin-bottom: 50px">
        <code>{{ this.getToken() }}</code>
      </p>
      <a href="#">
        <b-img style="width: 200px" src="/images/app-store.png" />
      </a>
      <a href="#">
        <b-img style="width: 200px" src="/images/play-store.png" />
      </a>
    </b-jumbotron>
  </b-container>
</template>


<script>
export default {
  name: 'apps',
  data: function () {},
  computed: {},
  beforeMount: async function () {},
  methods: {
    getToken() {
      return this.$route.params.token;
    },
  },
  components: {},
};
</script>